import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "./Invite.module.scss";
import MobileContext from "../../context/mobile";
import SliderBtn from '../SliderBtn/SliderBtn';
import { Link } from 'react-router-dom';
import Constructions from '../Constructions/Constructions';
import clsx from 'clsx';

const Invite = (props) => {
  const { title, desc, descMobile, form, color, use, className } = props;
  const isMobile = useContext(MobileContext);
  let classWrap = `${styles.wrap}`;

  if (form !== undefined && styles[`wrap_${form}`] !== undefined) {
    classWrap += ` ${styles[`wrap_${form}`]}`;
  }
  if (color !== undefined && styles[`wrap_${color}`] !== undefined) {
    classWrap += ` ${styles[`wrap_${color}`]}`;
  }
  if (use !== undefined && styles[`wrap_${use}`] !== undefined) {
    classWrap += ` ${styles[`wrap_${use}`]}`;
  }

  let constructions = <div className={styles.constructions}><Constructions color={color}/></div>
  if (isMobile && form === undefined) {
    constructions = null;
  }
  return (
    <>
      <div className={clsx(classWrap, className)} data-header-trigger={true}>
        <div className={styles.info}>
          <div className={styles.info__text} data-animate={'fade-in-up'}>
            <h2 className={styles.title}>{title}</h2>
            <div className={styles.desc}>{descMobile && isMobile ? descMobile : desc}</div>
          </div>
          {/* <a href='https://spb.hh.ru/employer/8121' target='_blank' rel="noreferrer" className={styles.btn}>
            <SliderBtn size={'big'} text={'Посмотреть вакансии'} color={`${color}_invite`} />
          </a> */}
          <Link to={{ pathname: `../vacancies`, search: window.location.search }} className={styles.btn}>
            <SliderBtn size={'big'} text={'Посмотреть вакансии'} color={`${color}_invite`} />
          </Link>
          <a href="http://vk.com/teamrpharm" target='_blank' rel='noreferrer' className={styles.social}>
            <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M27 54C41.9117 54 54 41.9117 54 27C54 12.0883 41.9117 0 27 0C12.0883 0 0 12.0883 0 27C0 41.9117 12.0883 54 27 54ZM12.4258 18.3833C12.6641 29.8232 18.384 36.6982 28.4123 36.6982H28.9808V30.1532C32.6658 30.5199 35.4521 33.2149 36.5705 36.6982H41.7773C40.3473 31.4916 36.5888 28.6132 34.2421 27.5133C36.5888 26.1566 39.8888 22.8566 40.6771 18.3833H35.947C34.9204 22.0133 31.8774 25.3133 28.9808 25.6249V18.3833H24.2506V31.0699C21.3173 30.3366 17.6141 26.7799 17.4491 18.3833H12.4258Z" fill="white" />
            </svg>

            <span>Присоединяйтесь к нам в соцсетях</span>
          </a>
        </div>
        {constructions}
      </div>
    </>
  );

}

export default Invite;
